export default "__VITE_ASSET__BOHfYOcx__"